import {
  currencyFields,
  inputCategories,
  matchTypeLabels,
  matchTypesWithMatchCase,
  matchTypeToCategory,
  nonBlankValueFields,
} from './constants'

export const getInputCategory = (matchType, field) => {
  if (!matchType) return null

  const category = matchTypeToCategory[matchType] || null

  if (field && currencyFields.includes(field) && category !== inputCategories.range) {
    return inputCategories.currency
  }

  return category
}

export const hasMatchCaseOption = matchType => {
  return matchTypesWithMatchCase.includes(matchType)
}

export const getPropertyOptions = (properties, t) => {
  return Object.entries(properties).map(([field, prop]) => ({ value: field, label: t(prop.label) }))
}

export const getMatchTypeOptions = (fieldConfig, t) => {
  if (!fieldConfig) return []

  return fieldConfig.matchTypes.map(matchType => ({
    value: matchType,
    label: t(matchTypeLabels[matchType]),
  }))
}

export const isEmptyValue = value => value === '' || value === null || value === undefined

export const isNonBlankValueField = field => nonBlankValueFields.includes(field)

export const isBlankValue = value => isEmptyValue(value) || String(value).trim() === ''

export const hasBlankValues = values => !values?.length || values.some(isBlankValue)

export const isRangeInvalid = (min, max) => {
  if (isEmptyValue(min) || isEmptyValue(max)) return false

  const minNumber = parseFloat(min)
  const maxNumber = parseFloat(max)

  if (Number.isNaN(minNumber) || Number.isNaN(maxNumber)) return false

  return minNumber >= maxNumber
}
